import { useTranslation } from '../../../application/hooks/useTranslation';
import { formatNumber } from '../../../domain/formatters/date';
import { Button } from '../ui/Button';

export interface LedgerPagerProps {
  page: number;
  totalPages: number;
  onPage: (page: number) => void;
}

/** Prev / "Page x of y" / Next in a nav landmark; the page text is a polite live region. */
export function LedgerPager({ page, totalPages, onPage }: LedgerPagerProps) {
  const { t, locale } = useTranslation();
  return (
    <nav className="pager" aria-label={t('commissions.pagerLabel')}>
      <Button variant="secondary" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="ledger-prev">
        {t('common.prev')}
      </Button>
      <span className="muted tabular" aria-live="polite" data-testid="ledger-page">
        {t('commissions.pageOf', { page: formatNumber(page, locale), total: formatNumber(totalPages, locale) })}
      </span>
      <Button variant="secondary" disabled={page >= totalPages} onClick={() => onPage(page + 1)} data-testid="ledger-next">
        {t('common.next')}
      </Button>
    </nav>
  );
}
